<div class="dl-empty">
  <span class="dl-empty__icon" *ngIf="icon">
    <mat-icon>{{ icon }}</mat-icon>
  </span>

  <p class="dl-empty__title" *ngIf="title">{{ title }}</p>

  <p class="dl-empty__message">
    <ng-content></ng-content>
  </p>

  <div class="dl-empty__actions">
    <ng-content select="[emptyStateActions]"></ng-content>
  </div>
</div>
